export const RECONCILIATION_DRY_RUN_ACTION = 'reconciliation_dry_run'
export const RECONCILIATION_DELAY_HOURS = 24

const RECONCILIATION_DELAY_MS = RECONCILIATION_DELAY_HOURS * 60 * 60 * 1000

export const safeObject = (value) => {
    if (!value) return {}
    if (typeof value === 'object') return value

    try {
        return JSON.parse(value)
    } catch (_error) {
        return {}
    }
}

export const getReconciliationSummary = (row = {}) => {
    const afterValue = safeObject(row?.afterValue)
    return afterValue.summary || {}
}

export const getSummaryNumber = (summary = {}, key) => Number(summary[key] || 0)

export const isReconciliationLogDelayed = (row, now = new Date()) => {
    if (!row?.regTime) return false

    const regTime = new Date(row.regTime)
    if (Number.isNaN(regTime.getTime())) return false

    return now.getTime() - regTime.getTime() > RECONCILIATION_DELAY_MS
}

export const resolveReconciliationStatus = (row, now = new Date()) => {
    if (!row) {
        return {
            key: 'missing',
            label: '점검 없음',
            color: 'default',
            delayed: false,
        }
    }

    const summary = getReconciliationSummary(row)
    const issueCount = getSummaryNumber(summary, 'issueCount')
    const p0Count = getSummaryNumber(summary, 'p0Count')
    const requiresApprovalCount = getSummaryNumber(summary, 'requiresApprovalCount')
    const delayed = isReconciliationLogDelayed(row, now)

    if (issueCount > 0 || p0Count > 0 || requiresApprovalCount > 0) {
        return {
            key: 'issue',
            label: '이슈 있음',
            color: 'error',
            delayed,
        }
    }

    if (delayed) {
        return {
            key: 'delayed',
            label: '점검 지연',
            color: 'warning',
            delayed,
        }
    }

    return {
        key: 'ok',
        label: '정상',
        color: 'success',
        delayed: false,
    }
}
